import { Component, Element, Event, EventEmitter, h, Host, Method, Prop, State } from "@stencil/core";

const hiddenClass = "ux-dropdown__item--hidden";

@Component({
    tag: "ux-filterable-list",
    shadow: true,
    styleUrl: "filterable-list.scss"
})
export class FilterableList {
    @Element() domNode: HTMLUxFilterableListElement;

    /**
     * Enable the filter input field
     *
     */
    @Prop({ reflect: true }) readonly filterable: boolean = false;

    /**
     * Placeholder for the search input field
     */
    @Prop() readonly searchPlaceholder: string = "Search";

    /**
     * Emits the value of the search field on change
     */
    @Event() uxChange: EventEmitter;

    @State() items = [];
    @State() slotLabels: string[] = [];
    @State() filterString = "";

    /** list element that hosts all items */
    private ul: HTMLUListElement = null;

    /**
     * Check if the searchVal is in the filter
     * @param searchVal the value to check against the filter
     * @returns true if the searchVal is in the filter
     */
    private isInFilter(searchVal: string): boolean {
        return this.filterString.length === 0 || searchVal.toLowerCase().includes(this.filterString);
    }

    /**
     * Set the filter values by elements
     * @deprecated please use slotted elements instead
     */
    @Method()
    async setFilterValues(filterValues: []) {
        this.items = filterValues;
    }

    /**
     * Control the visibility of the items
     * @param event InputElement event
     * @returns
     */
    private onFilterChange(event: CustomEvent) {
        this.uxChange.emit(event);
        if (this.items.length > 0) {
            return;
        }
        const target = event.target as HTMLInputElement;
        this.filterString = target.value.toLowerCase();

        if (this.slotLabels.length === 0 && !this.slotLabels[0]) {
            this.slotLabels.forEach((label, i) => {
                const element = this.ul.children[i];
                if (this.isInFilter(label)) {
                    element.classList.remove(hiddenClass);
                } else {
                    element.classList.add(hiddenClass);
                }
            });
        }
        const slottedElements = this.domNode.shadowRoot.querySelector("slot").assignedElements();
        if (slottedElements.length > 0) {
            slottedElements.forEach((element: HTMLUxCheckboxListItemElement) => {
                const label = element.getAttribute("label");
                if (this.isInFilter(label)) {
                    element.hidden = false;
                } else {
                    element.hidden = true;
                }
            });
        }
    }

    public render() {
        const filterInput = this.filterable && (
            <div class="ux-list__filter">
                <input
                    class="ux-list__filter-input ux-input"
                    type="text"
                    placeholder={this.searchPlaceholder}
                    onKeyUp={this.onFilterChange.bind(this)}
                />
            </div>
        );
        const hasItems: boolean = this.items.length > 0;

        return (
            <Host>
                {filterInput}
                <ul ref={(el) => (this.ul = el as HTMLUListElement)} class="ux-dropdown__list">
                    {hasItems &&
                        this.items.length > 0 &&
                        this.items.every((item) =>
                            item.assignedNodes()(
                                <li
                                    class={{
                                        [hiddenClass]: !this.isInFilter(item.label)
                                    }}
                                >
                                    <ux-checkbox-list-item label={item.label} value={item.value} />
                                </li>
                            )
                        )}
                </ul>
                <ul>
                    <slot />
                </ul>
            </Host>
        );
    }
}
